import React, { useState } from 'react';

export default function CopyToClipboard({ text, btnStyle, btnClassName }) {
    const [copied, setCopied] = useState(false);
    if (copied) {
        return (
            <button
                type="button"
                className={btnClassName}
                style={btnStyle}
            >
                <svg width={18} height={18} viewBox="0 0 14 14" focusable="false" class="chakra-icon css-onkibi"><g fill="currentColor"><polygon points="5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"></polygon></g></svg>
            </button>
        );
    }
    return (
        <button
            type="button"
            className={btnClassName}
            style={btnStyle}
            onClick={() => {
                navigator.clipboard.writeText(text);
                setCopied(true);
                setTimeout(() => setCopied(false), 1000);
            }}
        >
            <svg width={18} height={18} viewBox="0 0 24 24" focusable="false"><path fill="currentColor" d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"></path></svg>
        </button>
    );
}
